"use client";

import { AnimatedList } from "@/components/componentAnimation/animatedListComponent";
import sharedStyles from "../shared/SectionTitle.module.css";
import styles from "./ImportantThingsSection.module.css";
import type { ImportantThingItem } from "@/app/student-life/accommodation/types";

type ImportantThingsSectionProps = {
  items: ImportantThingItem[];
  sectionTitle: string;
};

export default function ImportantThingsSection({
  items,
  sectionTitle,
}: ImportantThingsSectionProps) {
  return (
    <section className={styles.importantSection}>
      <h2 className={sharedStyles.sectionTitle}>{sectionTitle}</h2>

      <AnimatedList isHorizontal={false} className={styles.importantGrid}>
        {items.map((item) => (
          <article key={item.id} className={styles.importantCard}>
            <div className={styles.importantCardHeader}>
              <div className={styles.importantIconWrap}>
                <img src={item.icon} alt="" className={styles.importantIcon} />
              </div>
              <h3 className={styles.importantCardTitle}>{item.title}</h3>
            </div>

            <div className={styles.importantCardBody}>
              <ul className={styles.importantList}>
                {item.points.map((point, index) => (
                  <li key={index} className={styles.importantListItem}>
                    {point}
                  </li>
                ))}
              </ul>

              {item.links && item.links.length > 0 && (
                <div className={styles.importantLinks}>
                  {item.links.map((link, i) => (
                    <a
                      key={link.label}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.importantLinkBtn}
                      style={{ animationDelay: `${i * 0.1}s` }}
                    >
                      {link.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </article>
        ))}
      </AnimatedList>
    </section>
  );
}
